module.exports = __webpack_public_path__ + "static/paris-021-423207ab8aed866007e758f885666683.jpg";